export default "data:video/mp2t;base64,ZXhwb3J0IHR5cGUgSW5jaWRlbnRzU3RhdHVzR3JvdXAgPSAiYWN0aW9uLW5lZWRlZCIgfCAicmVzb2x2ZWQiOwo="